module.exports = __webpack_public_path__ + "img/xd.2f0803d8.svg";